import { applyMiddleware, createStore } from 'redux';
import { rootReducer } from 'store/rootReducer';
import { composeWithDevTools } from 'redux-devtools-extension';
import reduxThunk from 'redux-thunk';
import persistState from 'redux-localstorage';

// Get client hash, stored as global variable in the
// index.html: <script></script> (created during the build of the client)
declare let AC_CLIENT_HASH: string | null;

/**
 * Gets state of the redux from the browsers local storage.
 */
const getPersistedState = () => {
  if (typeof AC_CLIENT_HASH === 'undefined') {
    return {};
  }

  const clientBuildHash = localStorage.getItem('ac-client-hash');
  localStorage.setItem('ac-client-hash', AC_CLIENT_HASH as string);

  // Compare the hash of the current build and the one stored in the Browser
  // if they differ, clear the previous application state
  const isHashDifferent: boolean = String(clientBuildHash) !== String(AC_CLIENT_HASH);
  if (isHashDifferent) {
    console.log('Different client source code, rehydrating redux state');
    localStorage.removeItem('redux');
    return {};
  } else {
    // Use saved state
    console.log('Reusing existing state');
    return localStorage.getItem('redux') ? JSON.parse(localStorage.getItem('redux') as any) : {};
  }
};

const composeEnhancers = composeWithDevTools({
  // Specify name here, actionsBlacklist, actionsCreators and other options if needed
});

//Load the state from the storage
const persistedState = getPersistedState();

/**
 * Custom slicer for persisted state plugin, configured to store only parts we need
 * Taken from: https://github.com/elgerlambert/redux-localstorage
 */
const persistedStateEnhancer = () =>
  persistState(
    null as any,
    {
      // These slices of local redux stated will be synced through localStorage
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      slicer: (paths: any) => (state: any) => {
        return {
          analytics: {
            ui: state['analytics']['ui'],
          },
        };
      },
    } as any,
  );

// create store with dev tools and custom logger
const store = createStore(
  rootReducer,
  persistedState,
  composeEnhancers(persistedStateEnhancer(), applyMiddleware(reduxThunk)) as any,
);

// export store singleton instance
export default store;
